import { isPageUrl } from './../url/is-page-url';

import type { LinkOldOrNew } from './types';

export const isPageLink = (link: LinkOldOrNew): boolean =>
  typeof link.url === 'string' && isPageUrl(link?.url);
